export const locale = {
    lang: "en",
    data: {
        MAP: {
            ShowDisabledDevices: "Show disabled devices",
        },
    },
};
